import {Component, OnInit, ViewChild} from '@angular/core';
import {UtilisateurSigalett} from './shared/models/utilisateur-sigalett.model';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {CommunicationUtilisateurComponent, NotificationServiceJsVersStatutWebsocketService} from 'sigale-angular';
import {PrimeNGConfig} from 'primeng/api';
import {AuthService} from './shared/services/auth-service.service';

@Component({
	selector: 'main',
	templateUrl: './main.component.html',
	styleUrl: './main.component.scss'
})
export class MainComponent implements OnInit {
	@ViewChild(CommunicationUtilisateurComponent) communicationUtilisateur: CommunicationUtilisateurComponent;
	utilisateur: UtilisateurSigalett;
	langueParDefaut = 'FR';
	langueUtilisateur: string;

	codeLangueUtilisateur: string;

	constructor(private router: Router,
		private authService: AuthService,
		private translateService: TranslateService,
		private primeNGConfig: PrimeNGConfig,
		private activatedRoute: ActivatedRoute,
		private notificationServiceJsVersStatutWebsocketService: NotificationServiceJsVersStatutWebsocketService,) {
		translateService.setDefaultLang(this.langueParDefaut);
		this.langueUtilisateur = this.langueParDefaut.toLowerCase();
	}

	ngOnInit(): void {
		this.notificationServiceJsVersStatutWebsocketService.initTacheReconnexion();

		this.utilisateur = this.authService.getUtilisateurConnecte();

		this.codeLangueUtilisateur = this.langueParDefaut;
		this.authService.mettreAJourLangueUtilisateurFrontend(this.langueUtilisateur);

		if (this.utilisateur.langue) {
			this.codeLangueUtilisateur = this.utilisateur.langue;
		}

		this.translateService.stream('COMPONENTS.PRIMENG').subscribe(data => {
			this.primeNGConfig.setTranslation(data);
		});

		// à chaque changement de page, on va récupérer le message communiqué aux users s'il est existant
		this.router.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				// on met à jour manuellement car la change detection d'Angular se fait après cette instruction
				this.communicationUtilisateur.mettreAJourConditionAffichage(this.doitAfficherMessage());
				this.communicationUtilisateur.recupererCommunicationUtilisateur();
			}
		});
	}

	/**
	 * Détermine s'il faut afficher le message aux utilisateurs
	 */
	doitAfficherMessage(): boolean {
		return this.activatedRoute.snapshot.firstChild.data['afficherMessageUtilisateur'];
	}
}
